/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IBloodBank } from 'app/shared/model/blood-bank.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { RhType } from 'app/shared/model/enumerations/rh-type.model';
import { BloodProducts } from 'app/shared/model/enumerations/blood-products.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IBloodBankRequest {
  id?: string;
  bloodType?: keyof typeof BloodGroup | null;
  rhType?: keyof typeof RhType | null;
  productType?: keyof typeof BloodProducts | null;
  requestedDate?: number | null;
  dispatchedDate?: number | null;
  unitsRequested?: number | null;
  unitsDispatched?: number | null;
  reason?: string | null;
  requesterId?: string | null;
  requesterType?: keyof typeof AddedByType | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  transfused?: boolean | null;
  ipNumber?: string | null;
  indications?: string | null;
  uhid?: string | null;
  entityType?: keyof typeof EntityType | null;
  entityId?: string | null;
  bank?: IBloodBank | null;
  forPatient?: IGlucoUser | null;
  status?: IClinicalDictionary | null;
  productComponent?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IBloodBankRequest> = {
  active: false,
  transfused: false,
};
